import React from 'react';

const FileInput = ({ handleCargarEscaneosFromFile }) => {
  return (
    <div>
      <label htmlFor="file-upload" className="custom-file-upload">
        Cargar códigos
      </label>
      <input 
        id="file-upload" 
        type="file" 
        accept=".txt" 
        onChange={handleCargarEscaneosFromFile} 
      />
    </div>
  );
};

export default FileInput;